import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPacket = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m7.904 15.168 6.816-3.888-.032-5.072 1.312-3.824-4.16 1.808-3.072-1.504-1.184-2.688-7.584 2.56 1.552 3.52.128 5.248zm-5.632-9.824-.976-2.208 5.76-1.952.72 1.616zm5.408 3.136-4.576-2.464 5.296-2.448 2.288 1.136-2.144.928-.8 2.816zm1.2-.528.464-1.616 5.04-2.192-.56 1.632zm-1.488 5.776-4.768-2.944-.096-3.984 4.672 2.496zm.96.08-.192-4.496 5.568-2.448.032 3.856z",
		fill: "#2b2b2b"
	})
});
export default SvgPacket;
